import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

/**
 * @typedef {object} SearchControlTextProps
 * @property {string} [selectedSearchText]
 * @property {(value: string) => void} setSearchText
 * @property {string} placeholder
 */

/**
 * @param {SearchControlTextProps} props
 */
const SearchControlText = props => {
  const { selectedSearchText, setSearchText, placeholder } = props;
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      setSearchText(e.target.value);
    }
  };

  return (
    <div className='item-search__search-padding'>
      <div className='item-search__search-block'>
        <SearchIcon className='item-search__icon' />
        <input
          className='item-search__input'
          type='text'
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          defaultValue={selectedSearchText}
        />
      </div>
    </div>
  );
};

export default SearchControlText;
